/* istanbul ignore file */
import { Box } from '@mui/material';
import { CreateForm, TextInput } from 'framework/form';
import { usePrivilegedCandidateId } from '../../privilegedAccessRouting';
import { useExternalAccountsService } from '../externalAccountsService';
import { InputTooltip, CreatePageLayout, FormSection, FormRow } from 'framework/ui/layout';
import { useCandidateUrl } from 'domain/shared/candidate';
import useCreationResponseHandler from './accountsCreationResponseHandler';

const InternAccountsCreationForm = () => {
  const candidateId = usePrivilegedCandidateId();
  const { getProfileEditUrl } = useCandidateUrl();
  const { createExternalAccounts, getCandidateDataForForm, getInternValidationSchema } = useExternalAccountsService();
  const { handleCreationResponse } = useCreationResponseHandler();

  const submitFormFunc = async (data: any) => {
    // eslint-disable-next-line no-param-reassign
    data.candidateId = candidateId;
    const response = await createExternalAccounts(data);
    handleCreationResponse(response, { candidateId });
  };

  return (
    <CreateForm
      getDataFunc={() => getCandidateDataForForm(candidateId)}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        execute: () => {},
      }}
      getValidationSchemaFunc={getInternValidationSchema}
    >
      <CreatePageLayout title="Create: Azure and Redmine accounts">
        <FormSection title="Intern account information">
          <FormRow>
            <TextInput label="First name" source="firstNameEn" disabled />
            <TextInput label="Last name" source="lastNameEn" disabled />
            <TextInput label="Syberry Email" source="workingEmail" />
          </FormRow>
          <FormRow>
            <TextInput label="Private note password" source="privateNotePassword" />
          </FormRow>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <a href={getProfileEditUrl(candidateId)} target="_blank" rel="noreferrer">
              Open candidate profile
            </a>
            <InputTooltip
              message="Reload page to get profile changes"
              source=""
              size="small"
              sx={{ marginLeft: '10px' }}
            />
          </Box>
        </FormSection>
      </CreatePageLayout>
    </CreateForm>
  );
};

export default InternAccountsCreationForm;
